module.exports = __webpack_public_path__ + "static/media/stfrancisxavier.ff313807.jpg";